import './styles/index.css'
import './i18n'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { ConfigErrorScreen } from './app/ConfigErrorScreen'
import { configResult } from './config'

const root = createRoot(document.getElementById('root')!)

// Config gate: an invalid runtime config renders a branded error instead of a blank page.
if (!configResult.ok) {
  root.render(<ConfigErrorScreen issues={configResult.issues} />)
} else {
  // Imported lazily so nothing that reads config runs before validation passes.
  void import('./app/router').then(({ router }) => {
    root.render(
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>,
    )
  })
}
